import { Box } from "@mui/material";
import Button from "../../../design/Button";
import colors from "../../../design/colors";
import styles from "../../../design/styles";
import customStyles from "./styles";

const NumberNotVerified = ({ phoneNumber, onSendCode, onCancel, isLoading }) => {
  return (
    <Box
      sx={customStyles.container}
    >
      {/* Content */}
      <Box
        sx={customStyles.numberNotVerifiedContent}
      >
        <p
          className="t6 medium-font nc-gray-900"
          style={customStyles.pl1}
        >
          Number not verified
        </p>
        <p
          className="t7 regular-font nc-gray-700"
          style={customStyles.pl2}
        >
          As you're on the <span className="medium-font">Instant trial</span>,
          outbound calls are limited to verified numbers only.
        </p>
        <p
          className="t7 regular-font nc-gray-700"
          style={customStyles.pl2}
        >
          To call <span className="medium-font">{phoneNumber}</span>, we'll send a one-time verification code to this
          number.
        </p>
      </Box>

      {/* Actions */}
      <Box
        sx={customStyles.actionsContainer}
      >
        <Button
          hierarchy="white"
          variant="outlined"
          buttonText="Cancel"
          disabled={isLoading}
          onClick={onCancel}
          styleOverride={{
            height: "36px",
            padding: "8px 16px",
            ...styles.t7,
          }}
        />
        <Button
          hierarchy="green"
          variant="contained"
          buttonText="Send code"
          isLoading={isLoading}
          disabled={isLoading}
          onClick={onSendCode}
          styleOverride={{
            height: "36px",
            padding: "8px 16px",
            ...styles.t7,
            color: colors.ic_white,
          }}
        />
      </Box>
    </Box>
  );
};

export default NumberNotVerified;
